<div class="bom-upload-content">
    <div class="d-flex justify-content-between w-100 align-items-center">
        <div class="improved-page-label">BoM Validation</div>
     
        <ng-template #nextButtonSpinner>
          <div class="la-ball-clip-rotate-multiple la-2x">
            <div></div>
            <div></div>
          </div>
        </ng-template>
    </div>
    <div class=" d-flex justify-content-between align-items-center mb-3 mt-3">
      <div class="d-flex">
      <label for="upload-EBOM">
        <div class="content-btn-photo me-3">
          <div class="btn btn-primary improved-add-btn d-flex align-items-center">
            <input type="file" name="EBOM" id="upload-EBOM" class="display-n" #fileInput (change)="onFileSelected($event, 'EBOM')">
            <img class="logo me-2" [src]="getImagePath+'cloud_upload.svg'" alt="EBOM Logo">
            <div>Upload E-BoM</div>
          </div>
        </div>
        <!-- <ng-template #foregroundSpinner>
          <div class="la-ball-clip-rotate-multiple la-2x">
            <div></div>
            <div></div>
          </div>
        </ng-template> -->
      </label>
      <button  class=" quote-view-draft-btn" (click)="downloadExcelFile()">
        <img class="quote-download-icon me-2" [src]="imagePath + 'download-white.svg'" alt="download"/> Download E-BoM Template</button>
    </div>
      <div class="d-flex justify-content-end gap-3" *ngIf="dataSource.data.length > 0">
        <button class="btn btn-outline-secondary improved-apply-btn" (click)="addRow()">Add Row</button>
        <button *ngIf="!nextButtonLoading; else nextButtonSpinner" class="btn btn-primary improved-add-btn" (click)="submitBOMFile()">Next</button>
      </div>
        <!-- <input type="file" name="EBOM" id="upload-EBOM" style="display:none"> -->

        <!-- <label for="upload-cad">
            <div mat-button class="content-btn-photo">
                <div class="btn-second">
                    <img class="logo" [src]="getImagePath+'cloud_upload.svg'" alt="CAD Logo">
                    <div>Upload M-BoM</div>
                </div>
            </div>
        </label>
        <input type="file" name="cad" id="upload-cad" style="display:none" accept=".zip"> -->
    </div>


    <div class="table-container mat-elevation-z8">
      <div class="custom-table custom-table-bom">
        <div class="">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!-- ID Column -->
             <!-- ID Column -->
         <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> Sr.</th>
          <td mat-cell *matCellDef="let element; let i = index"> {{getRowIndex(i) }} </td>
        </ng-container>

        <!-- Category Column -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef> Category </th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.isEdit; else viewMode">
              <mat-form-field appearance="outline">
                <input matInput [(ngModel)]="element.category" (ngModelChange)="onFieldChange(element, 'category', $event)">
              </mat-form-field>
            </ng-container>
            <ng-template #viewMode>{{element.category}}</ng-template>
          </td>
        </ng-container>

         <!-- Part Description Column -->
         <ng-container matColumnDef="description">
           <th mat-header-cell *matHeaderCellDef> Description </th>
           <td mat-cell *matCellDef="let element" style="width: 20%;">
             <ng-container *ngIf="element.isEdit; else viewMode">
               <mat-form-field appearance="outline">
                 <input matInput [(ngModel)]="element.description" (ngModelChange)="onFieldChange(element, 'description', $event)">
               </mat-form-field>
             </ng-container>
             <ng-template #viewMode>{{element.description}}</ng-template>
           </td>
         </ng-container>

         <!-- Part Description Column -->
         <ng-container matColumnDef="designator">
           <th mat-header-cell *matHeaderCellDef> Designator </th>
           <td mat-cell *matCellDef="let element">
             <ng-container *ngIf="element.isEdit; else viewMode">
               <mat-form-field appearance="outline">
                 <input matInput [(ngModel)]="element.designator" (ngModelChange)="onFieldChange(element, 'designator', $event)">
               </mat-form-field>
             </ng-container>
             <ng-template #viewMode>{{element.designator}}</ng-template>
           </td>
         </ng-container>

         <!-- MPN Column -->
         <ng-container matColumnDef="footprint">
           <th mat-header-cell *matHeaderCellDef> Footprint </th>
           <td mat-cell *matCellDef="let element">
             <ng-container *ngIf="element.isEdit; else viewMode">
               <mat-form-field appearance="outline">
                 <input matInput [(ngModel)]="element.footprint" (ngModelChange)="onFieldChange(element, 'footprint', $event)">
               </mat-form-field>
             </ng-container>
             <ng-template #viewMode>{{element.footprint}}</ng-template>
           </td>
         </ng-container>

         <!-- Make Column -->
         <ng-container matColumnDef="manufacturer">
           <th mat-header-cell *matHeaderCellDef> Manufacturer </th>
           <td mat-cell *matCellDef="let element">
             <ng-container *ngIf="element.isEdit; else viewMode">
               <mat-form-field appearance="outline">
                 <input matInput [(ngModel)]="element.manufacturer" (ngModelChange)="onFieldChange(element, 'manufacturer', $event)">
               </mat-form-field>
             </ng-container>
             <ng-template #viewMode>{{element.manufacturer}}</ng-template>
           </td>
         </ng-container>

         <!-- Description Column -->
         <ng-container matColumnDef="mpn">
           <th mat-header-cell *matHeaderCellDef> MPN  </th>
           <td mat-cell *matCellDef="let element">
             <ng-container *ngIf="element.isEdit; else viewMode">
               <mat-form-field appearance="outline">
                 <input class="mat-required" matInput [(ngModel)]="element.mpn" (keydown.space)="$event.preventDefault()" 
                 (ngModelChange)="onFieldChange(element, 'mpn', $event)" required>
                 <mat-error *ngIf="element.mpnError">MPN is required</mat-error>
               </mat-form-field>
             </ng-container>
             <ng-template #viewMode>{{element.mpn}}</ng-template>
           </td>
         </ng-container>

         <!-- Total Required Column -->
         <ng-container matColumnDef="quantity">
           <th mat-header-cell *matHeaderCellDef> Quantity </th>
           <td mat-cell *matCellDef="let element">
             <ng-container *ngIf="element.isEdit; else viewMode">
               <mat-form-field appearance="outline">
                 <input  class="mat-required" matInput type="number" [(ngModel)]="element.quantity" (ngModelChange)="onFieldChange(element, 'quantity', $event)" required>
                 <mat-error *ngIf="element.quantityError">Quantity is required and must be a positive number</mat-error>
               </mat-form-field>
             </ng-container>
             <ng-template #viewMode>{{element.quantity}}</ng-template>
           </td>
         </ng-container>

         <!-- Actions Column -->
         <ng-container matColumnDef="actions">
           <th mat-header-cell class="action-column" *matHeaderCellDef> Actions </th>
           <td mat-cell *matCellDef="let element">
             <ng-container *ngIf="element.isEdit; else editMode">
               <div class="d-flex">
               <button title="Approve" class="btn approval-btn" (click)="saveRow(element)">
                 <img [src]="getImagePath + 'Approve.svg'" alt="approve">
               </button>
               <button title="Reject" class="btn approval-btn" (click)="cancelEdit(element)">
                 <img [src]="getImagePath + 'cancel.svg'" alt="reject">
               </button>
             </div>
             </ng-container>
             <ng-template #editMode>
               <div class="d-flex gap-3">
                 <button class="improved-edit-action-btn me-1 p-0" title="Edit"
                 (click)="editRow(element)">
                 <img [src]="getImagePath + 'edit-lst.svg'" alt="edit" aria-label="edit">
               </button>
               <button class="improved-delete-action-btn p-0" title="Delete"
                 (click)="deleteRow(element.id)">
                 <img [src]="getImagePath + 'delete-lst.svg'" alt="delete" aria-label="delete">
               </button>
               </div>
             </ng-template>
           </td>
         </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell pb-2" colspan="14">
                <div class="no-results-message p-2">No data available</div>
              </td>
            </tr>
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons [ngStyle]="{
          display: dataSource.data.length > 25 ? 'block' : 'none'
        }"></mat-paginator>
      </div>
    </div>

    <ng-template #mapColumnBOM let-c="close" let-d="dismiss">
      <div class="midsize-modal clr-border-matfield">
        <div class="d-flex align-items-center content">
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h1 class="title">Map Column Headers</h1>
              <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
            </div>
            <form class="form" [formGroup]="mapColumnBOMForm">
              <div class="table-container mat-elevation-z8">
                <div class="custom-table">
                  <div class="custom-table-scroll-bar">
                    <table class="map-column-table" mat-table [dataSource]="dataSourcemapBOM">
                      <ng-container matColumnDef="vRapidiseHeader">
                        <th mat-header-cell *matHeaderCellDef> Rapidise Column Header </th>
                        <td mat-cell *matCellDef="let row">
                          {{row.vRapidiseHeader}}<span *ngIf="row.required" class="improved-required-color">*</span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="FileHeader">
                        <th mat-header-cell *matHeaderCellDef> File Column Header </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-form-field class="map-columns-field">
                            <mat-select formControlName="{{row.vFormControlName}}" placeholder="Select Column Header">
                              <mat-option *ngFor="let header of extractedColumnList" [value]="header">
                                {{ header }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </ng-container>
            
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsmapBOM"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsmapBOM;"></tr>
            
                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="19">
                          <div class="no-results-message-bom p-2">{{ dataSourcemapBOM.data.length === 0 ? 'No data available' : 'No data found' }}</div>
                        </td>
                      </tr>
                    </table>
                  </div>
            
                  <mat-paginator #paginatorBOMMapColumn="matPaginator" [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of Map Column Headers"
                   [ngStyle]="{display: dataSourcemapBOM.data.length > 25 ? 'block' : 'none'}"></mat-paginator>
                </div>
              </div>
              <div class="modal-footer px-5 pb-5 gap-2">
                <button type="button" class="cancel-button" (click)="CloseMapModal()">Cancel</button>
                <button type="submit" class="btn btn-primary improved-add-btn" (click)="MapColumnAndUploadFile()">Upload</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-template>